export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    `Nội dung hiển thị đã cũ. ` + `Tải lại trang để hiển thị phiên bản mới nhất?`
  );
  if (answer === true) {
    window.location.reload();
  }
};
